const PMLA_Policy =
  "https://s3.ap-south-1.amazonaws.com/liquide.money/uploads/broking-life/PMLA_Policies.pdf";
const Chinese_Wall_Information_Barrier_Policy =
  "https://s3.ap-south-1.amazonaws.com/liquide.money/uploads/broking-life/policies/2.CHINESE%20WALL_INFORMATION%20BARRIER%20POLICY.pdf";
const Code_of_Conduct_for_Stock_Broking =
  "https://s3.ap-south-1.amazonaws.com/liquide.money/uploads/broking-life/policies/3.Code%20of%20Conduct%20for%20Stock%20Broking.pdf";
const Internal_Code_of_Conduct_Policy =
  "https://s3.ap-south-1.amazonaws.com/liquide.money/uploads/broking-life/policies/4.INTERNAL%20CODE%20OF%20CONDUCT%20POLICY.pdf";
const Policy_for_dealing_with_Conflict_of_interest_of_Intermediaries_and_Associated_Persons_in_Securities_Market =
  "https://s3.ap-south-1.amazonaws.com/liquide.money/uploads/broking-life/policies/5.Policy%20for%20dealing%20with%20Conflict%20of%20interest%20of%20Intermediaries%20and%20Associated%20Persons%20in%20Securities%20Market.pdf";
const Internal_Policy_NISM_Series_VII_SORM =
  "https://s3.ap-south-1.amazonaws.com/liquide.money/uploads/broking-life/policies/6.Internal%20Policy%20w.r.t%20NISM%20Series%20VII%20-%20Securities%20Operation%20%26%20Risk%20Management%20%28SORM%29.pdf";
const Cyber_Incident_Response_Policy =
  "https://s3.ap-south-1.amazonaws.com/liquide.money/uploads/broking-life/policies/7.Cyber%20Incident%20Response%20Policy.pdf";
const Data_Classification_and_Protection_Policy =
  "https://s3.ap-south-1.amazonaws.com/liquide.money/uploads/broking-life/policies/8.Data%20Classification%20and%20Protection%20Policy%20%5BDCP%5D.pdf";
const Hiring_Policy =
  "https://s3.ap-south-1.amazonaws.com/liquide.money/uploads/broking-life/policies/9.Hiring_Policy.pdf";
const Client_Code_Modification_Policy_and_Error_Policy =
  "https://s3.ap-south-1.amazonaws.com/liquide.money/uploads/broking-life/policies/10.Client%20Code%20Modification%20Policy%20and%20Error%20Policy.pdf";
const Inactive_Account_Policy =
  "https://s3.ap-south-1.amazonaws.com/liquide.money/uploads/broking-life/policies/11.Inactive%20Account%20Policy.pdf";
const Information_Risk_Management_Policy =
  "https://s3.ap-south-1.amazonaws.com/liquide.money/uploads/broking-life/policies/12.Information%20Risk%20Management%20Policy.pdf";
const Internal_Shortage_Policies =
  "https://s3.ap-south-1.amazonaws.com/liquide.money/uploads/broking-life/policies/13.Internal%20Shortage%20Policies_151026.pdf";
const List_of_Client_Bank_Accounts =
  "https://s3.ap-south-1.amazonaws.com/liquide.money/uploads/broking-life/policies/14.List%20of%20Client%20Bank%20Accounts%20of%20Shareway%20Securities%20Private%20Limited.pdf";
const Outsourcing_Policy =
  "https://s3.ap-south-1.amazonaws.com/liquide.money/uploads/broking-life/policies/15.Outsourcing_Policy_2026.pdf";
const Policy_for_Voluntary_Freezing =
  "https://s3.ap-south-1.amazonaws.com/liquide.money/uploads/broking-life/policies/16.Policy%20for%20Voluntary%20Freezing.pdf";
const Policy_for_Handling_Technical_Glitches_Resulting_in_Business_Disruption =
  "https://s3.ap-south-1.amazonaws.com/liquide.money/uploads/broking-life/policies/17.Policy%20for%20handling%20technical%20glitches%20resulting%20in%20business%20disruption.pdf";
const Policy_on_Facsimile =
  "https://s3.ap-south-1.amazonaws.com/liquide.money/uploads/broking-life/policies/18.Policy%20on%20Facsimile.pdf";
const Policy_on_Insider_Trading =
  "https://s3.ap-south-1.amazonaws.com/liquide.money/uploads/broking-life/policies/19.Policy%20on%20Insider%20Trading.pdf";
const Policy_on_Pre_Funded_Instrument =
  "https://s3.ap-south-1.amazonaws.com/liquide.money/uploads/broking-life/policies/20.Policy%20on%20Pre%20Funded%20Instrument.pdf";
const Investor_Redressal_Mechanism =
  "https://s3.ap-south-1.amazonaws.com/liquide.money/uploads/broking-life/policies/21.Investor%20Redressal%20Mechanism.pdf";
const Policy_on_Pre_Funded_Instruments =
  "https://s3.ap-south-1.amazonaws.com/liquide.money/uploads/broking-life/policies/22.Policy%20on%20Pre-Funded%20Instruments.pdf";
const Security_Incident_and_Event_Management_Policy =
  "https://s3.ap-south-1.amazonaws.com/liquide.money/uploads/broking-life/policies/23.Security%20Incident%20and%20Event%20Management%20Policy.pdf";
const Policy_on_Unauthenticated_News_Circulation =
  "https://s3.ap-south-1.amazonaws.com/liquide.money/uploads/broking-life/policies/24.Policy%20on%20unauthenticated%20news%20circulation.pdf";
const Policy_on_Internal_Control =
  "https://s3.ap-south-1.amazonaws.com/liquide.money/uploads/broking-life/policies/25.Shareway_Policy_on_Internal_Control_15102026.pdf";
const RMS_Policy =
  "https://s3.ap-south-1.amazonaws.com/liquide.money/uploads/broking-life/policies/26.Shareway_RMS_Policy_v-6.pdf";
const Surveillance_Policy =
  "https://s3.ap-south-1.amazonaws.com/liquide.money/uploads/broking-life/policies/27.Surveillance%20Policy_Trading%20and%20DP%20Shareway.pdf";

export {
  PMLA_Policy,
  Chinese_Wall_Information_Barrier_Policy,
  Code_of_Conduct_for_Stock_Broking,
  Internal_Code_of_Conduct_Policy,
  Policy_for_dealing_with_Conflict_of_interest_of_Intermediaries_and_Associated_Persons_in_Securities_Market,
  Internal_Policy_NISM_Series_VII_SORM,
  Cyber_Incident_Response_Policy,
  Data_Classification_and_Protection_Policy,
  Hiring_Policy,
  Client_Code_Modification_Policy_and_Error_Policy,
  Inactive_Account_Policy,
  Information_Risk_Management_Policy,
  Internal_Shortage_Policies,
  List_of_Client_Bank_Accounts,
  Outsourcing_Policy,
  Policy_for_Voluntary_Freezing,
  Policy_for_Handling_Technical_Glitches_Resulting_in_Business_Disruption,
  Policy_on_Facsimile,
  Policy_on_Insider_Trading,
  Policy_on_Pre_Funded_Instrument,
  Investor_Redressal_Mechanism,
  Policy_on_Pre_Funded_Instruments,
  Security_Incident_and_Event_Management_Policy,
  Policy_on_Unauthenticated_News_Circulation,
  Policy_on_Internal_Control,
  RMS_Policy,
  Surveillance_Policy,
};
